import React from 'react';

const PageElement = ({ children }) => {
  return <main className="prose mx-auto max-w-7xl px-6 py-12">{children}</main>;
};

export default PageElement;
